import { render, staticRenderFns } from "./index.vue?vue&type=template&id=972da746&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=972da746&prod&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=972da746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972da746",
  null
  
)

export default component.exports